export const QUICK_BOOKS = 'quickbooks'
export const STRIPE_PAYMENTS = 'stripe'
